export default "__VITE_ASSET___8dPrHXw__"